import { render } from "./DonorDetailsPage.vue?vue&type=template&id=7fbaf688&scoped=true"
import script from "./DonorDetailsPage.vue?vue&type=script&lang=js"
export * from "./DonorDetailsPage.vue?vue&type=script&lang=js"

import "./DonorDetailsPage.vue?vue&type=style&index=0&id=7fbaf688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbaf688"]])

export default __exports__